import { Nutrients, NutrientTargets } from './food';
import { DateTime } from 'luxon';
import { assureIdForEntry, LogRecordState, LogRecordType, Log_EntryBase } from './user-log';

export interface Log_DayStart extends Log_EntryBase {
  type: LogRecordType.DayStart;
  nutrients: Nutrients; /** Sum of all nutrients in all meals in the day. Has to be recalculated when any meal in the day changes. */
  targets: NutrientTargets;
}

export function createDayStartEntry(date: DateTime): Log_DayStart {
  let entry = {} as Log_DayStart;
  entry.time_utc = date.toUTC().toISO();
  entry.timeOffset_min = date.offset;
  entry.type = LogRecordType.DayStart;
  entry.state = LogRecordState.Scheduled;
  entry.nutrients = {};
  entry.targets = {};

  assureIdForEntry(entry);
  return entry;
}
